var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content costPrice" },
    [
      _c("scrollTop", [_c("i", { staticClass: "icon-fa icon-fa-arrow-up" })]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body" }, [
              _c("div", { staticClass: "row sticky" }, [
                _c(
                  "div",
                  { staticClass: "col-md-8" },
                  [
                    _c("DrugSearchNew", {
                      attrs: { onSelect: _vm.selectDrug },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-4 flex" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-default",
                        on: {
                          click: function ($event) {
                            _vm.hideOrders = !_vm.hideOrders
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.hideOrders ? "Показать" : "Скрыть") +
                            " заявки\n              "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "vue-ladda",
                      {
                        attrs: {
                          "button-class": "p-l-5 btn btn-info",
                          "data-style": "zoom-in",
                          loading: _vm.btn_loading,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.getHistory()
                          },
                        },
                      },
                      [_vm._v("Показать\n              ")]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _vm.records
                ? _c("table", { staticClass: "table table-hover" }, [
                    _c(
                      "tbody",
                      [
                        _c("tr", [
                          _c("td", [
                            _vm._v("Начальное количество: "),
                            _c("strong", [_vm._v(_vm._s(_vm.qty))]),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v("Начальная стоимость: "),
                            _c("strong", [_vm._v(_vm._s(_vm.cost))]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.beforeInvoice, function (order) {
                          return !_vm.hideOrders
                            ? _c("tr", [
                                _c("td", [
                                  _c("strong", [_vm._v(_vm._s(order.id))]),
                                  _vm._v(
                                    ": " +
                                      _vm._s(order.date) +
                                      "\n              "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v("Количество: "),
                                  _c("strong", [_vm._v(_vm._s(order.qty))]),
                                ]),
                              ])
                            : _vm._e()
                        }),
                        _vm._v(" "),
                        _c("tr", [
                          _c("td", { attrs: { colspan: "2" } }, [
                            _vm._v(
                              "\n                Всего продано за период: "
                            ),
                            _c("strong", [_vm._v(_vm._s(_vm.preSold))]),
                            _vm._v(" по "),
                            _c("strong", [_vm._v(_vm._s(_vm.cost) + " EUR")]),
                            _vm._v(" остаток\n                "),
                            _c("strong", [
                              _vm._v(_vm._s(_vm.qty - _vm.preSold)),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.records, function (record, index) {
                          return [
                            _c("tr", { staticClass: "invoice_tr" }, [
                              _c("td", [
                                _c("p", [
                                  _vm._v("Инвойс: № "),
                                  _c("strong", [
                                    _vm._v(_vm._s(record.invoice.id)),
                                  ]),
                                  _vm._v(
                                    " дата: " +
                                      _vm._s(record.invoice.date) +
                                      "\n                    "
                                  ),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-xs btn-info smallModalBtn",
                                      on: {
                                        click: function ($event) {
                                          return _vm.showInvoice(
                                            record.invoice.id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "icon-fa icon-fa-eye",
                                      }),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v("Валюта: "),
                                  _c("strong", [
                                    _vm._v(_vm._s(record.invoice.currency)),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v("Количество: "),
                                  _c("strong", [
                                    _vm._v(_vm._s(record.invoice.qty)),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c("p", [
                                  _vm._v("Курс: "),
                                  _c("strong", [
                                    _vm._v(_vm._s(record.invoice.euro_rate)),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v("Стоимость: "),
                                  _c("strong", [
                                    _vm._v(_vm._s(record.invoice.price)),
                                  ]),
                                  _vm._v(
                                    " Стоимость без скидки:\n                    "
                                  ),
                                  _c("strong", [
                                    _vm._v(_vm._s(record.invoice.income_price)),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  record.invoice.currency !== "EUR"
                                    ? _c("span", [
                                        _vm._v("EUR:\n                    "),
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              Math.round(
                                                record.invoice.price *
                                                  record.invoice.euro_rate *
                                                  10000
                                              ) / 10000
                                            )
                                          ),
                                        ]),
                                        _vm._v(
                                          "\n                    на сумму "
                                        ),
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              Math.round(
                                                record.invoice.price *
                                                  record.invoice.euro_rate *
                                                  record.invoice.qty *
                                                  10000
                                              ) / 10000
                                            )
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("tr", { staticClass: "cost_tr" }, [
                              _c("td", [
                                _vm._v("Себестоимость: "),
                                _c("strong", [
                                  _vm._v(_vm._s(record.drug.cost)),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v("Количество: "),
                                _c("strong", [_vm._v(_vm._s(record.drug.qty))]),
                                _vm._v(" на сумму\n                  "),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      Math.round(
                                        record.drug.qty *
                                          record.drug.cost *
                                          1000
                                      ) / 1000
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _vm._l(record.orders, function (orders) {
                              return !_vm.hideOrders
                                ? _vm._l(orders, function (order) {
                                    return _c(
                                      "tr",
                                      { class: { writeOff_tr: order.invoice } },
                                      [
                                        _c(
                                          "td",
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-xs btn-info ml-1 mr-2",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.orderToEdit(
                                                      order.id
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "icon-fa icon-fa-eye",
                                                }),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            order.invoice
                                              ? [
                                                  _vm._v(
                                                    "\n                      Списание: № "
                                                  ),
                                                  _c("strong", [
                                                    _vm._v(_vm._s(order.id)),
                                                  ]),
                                                  _vm._v(
                                                    " : " +
                                                      _vm._s(order.date) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              : [
                                                  _vm._v(
                                                    "\n                      № "
                                                  ),
                                                  _c("strong", [
                                                    _vm._v(_vm._s(order.id)),
                                                  ]),
                                                  _vm._v(
                                                    " : " +
                                                      _vm._s(order.date) +
                                                      "\n                    "
                                                  ),
                                                ],
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            "\n                    Количество: "
                                          ),
                                          _c("strong", [
                                            _vm._v(_vm._s(order.qty)),
                                          ]),
                                          _vm._v(" "),
                                          order.minus_error
                                            ? _c("span", [
                                                _vm._v(
                                                  "ОШИБКА - выход в минус"
                                                ),
                                              ])
                                            : _vm._e(),
                                        ]),
                                      ]
                                    )
                                  })
                                : _vm._e()
                            }),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", { attrs: { colspan: "2" } }, [
                                _vm._v(
                                  "\n                  Всего продано за период: "
                                ),
                                _c("strong", [_vm._v(_vm._s(record.sold))]),
                                _vm._v(" по "),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(record.drug.cost) +
                                      "\n                  EUR"
                                  ),
                                ]),
                                _vm._v(" остаток "),
                                _c("strong", [
                                  _vm._v(_vm._s(record.drug.qty - record.sold)),
                                ]),
                                _vm._v(" "),
                                record.drug.qty - record.sold
                                  ? _c("span", [
                                      _vm._v("на сумму "),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            Math.round(
                                              (record.drug.qty - record.sold) *
                                                record.drug.cost *
                                                10000
                                            ) / 10000
                                          )
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                              ]),
                            ]),
                          ]
                        }),
                      ],
                      2
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }